import * as React from 'react';
import Select from 'react-select';

const MySelect = (props: any) => {
  const customStyles = {
    container: (provided: any, state: any) => ({
      ...provided,
      marginBottom: '0.5rem',
    }),
    option: (provided: any, state: any) => ({
      ...provided,
    }),
    control: (provided: any, state: any) => ({
      ...provided,
      minHeight: 'auto',
      maxHeight: 33,
      backgroundColor: state.isDisabled ? '#e9ecef' : provided.backgroundColor,
      borderColor: state.isDisabled ? '#ced4da' : provided.borderColor,
    }),
    dropdownIndicator: (provided: any, state: any) => ({
      ...provided,
      padding: 5,
    }),
    singleValue: (provided: any, state: any) => ({
      ...provided,
      color: state.isDisabled ? '#495057' : provided.color,
    }),
  };

  return <Select {...props} styles={customStyles} />;
};

export default MySelect;
